import gql from 'graphql-tag';

export const SERVICE_ITEM_FRAGMENT = gql`
  fragment ServiceItemFragment on EstimateServiceItem {
    id
    account_id
    service_item_id
    sku
    name
    unitCost
    unitRetailPrice
    description
    type
    isTaxable
    isArchived
    order
    quantityLaborHours
    quantityLaborMinutes
    quantityMaterial
    estimateUnitRetailPrice
    estimateName
    estimateDescription
    createdAt
    updatedAt
  }
`;
